import {BaseSyntheticEvent} from 'react';
import {config} from '../init/config';
import {BreadcrumbsDTO} from '../models/dto/BreadcrumbsDTO';

// Generic Helper utils
export const executeAction = (e: BaseSyntheticEvent, action: () => void) => {
    e.stopPropagation();
    action();
};

export const isTrue = (value: string): boolean => {
    return (/true/i).test(value);
};

export const isFalse = (value: string): boolean => {
    return !isTrue(value);
};

export const validateContainsWhitespace = (value: string): boolean => {
    if (isNullOrEmpty(value)) {
        return true;
    }

    return (value.indexOf(' ') >= 0);
};

export const SPECIAL_CHARACTERS = '@#$%&?*`~\'<>\\"/';

export const SPECIAL_END_CHARACTERS = '\\/.';

export const validateContainsSpecialCharacter = (value: string | null): boolean => {
    return (!value) || (/[@#$%&?*`~'<>\\"/]/).test(value);
};

export const validateEndWithSpecialCharacter = (value: string | null): boolean => {
    return (!value) || (/[\\/.]$/).test(value);
};

export const isNullOrEmpty = (value: string | null): boolean => {
    return (!value) || (/^\s*$/).test(value);
};

//UI specific Helper utils. The utils are specially designed to be used in forms, dialogs etc.
//Example: the usage of isValidText can be applied with it's implementation but the usage of the function
//facilitates a lot the validation check of a text field(user input). The same function is not appropriate for usage
//into functions of general purpose as isValidText means nothing but the syntax of check for undefined and not null is meaningful.
export const isValidText = (value: string | null | undefined): boolean => {
    return (value !== undefined) && (!isNullOrEmpty(value));
};

export const validateThumbnailImage = (image: File | null): boolean => {
    if ((image === undefined) || (!image) || (image.size === undefined) || (!image.size) || (image.size === 0)) {
        return true;
    }

    return (image.size <= (config.DLS_THUMBNAIL_MAX_SIZE * 1024 * 1024)) as boolean;
};

export const pathToResource = (breadcrumbs: BreadcrumbsDTO[]): string => {
    let newPath = breadcrumbs.map(obj => obj.labelPathPart);
    return ('/'.concat(newPath.join('/')));
};

export const getPath = (pathParam: string, nameParam: string): string => {
    let path = '/';
    if (!isNullOrEmpty(pathParam)) {
        path = pathParam;
    }

    if (isNullOrEmpty(nameParam)) {
        nameParam = '';
    }

    if (path !== '/') {
        path = path + '/';
    }

    return path + nameParam;
};

export const getDateStart = (date: Date): Date => {
    let effectiveDate = new Date(date);
    effectiveDate.setHours(0, 0, 0, 0);

    return effectiveDate;
};

export const getEffectiveDate = (): Date => {
    return getDateStart(new Date());
};

export const convertToStringArray = (value: string[] | null | undefined): string[] => {
    if ((value !== undefined) && value && (value.length > 0)) {
        return value.toString().replace('[', '').replace(']', '').split(',')
            .filter(item => (!isNullOrEmpty(item)))
            .map(item => item.trim());
    }

    return [];
}
